'use strict';
import ngMaterial from 'angular-material';
import ngFileUpload from 'ng-file-upload';
import dialog from '../dialog';
import RxCredentialListController from './rx-credential-list.controller';
import RxCredentialEditForm from '../forms/account/rx-credential-edit';
import RxCredentialListService from './rx-credential-list.service';
import RxCredentialAddForm from '../forms/account/rx-credential-add';
import { RxCredentialEvents } from './rx-credential-events';
export default angular.module('directives.rxCredentialList', [RxCredentialEditForm, RxCredentialAddForm,
    ngMaterial, dialog, ngFileUpload])
    .service('RxCredentialListService', RxCredentialListService)
    .service('RxCredentialEvents', RxCredentialEvents)
    .component('rxCredentialList', {
    template: require('./rx-credential-list.html'),
    controller: RxCredentialListController
})
    .name;
//# sourceMappingURL=index.js.map